define('SageDotCom/Components/Content/DigitalNewsroom/DigitalNewsroomFilter',["jquery",
    "knockout",
    "underscore",
    "eventManager",
    "jqueryQuerystring"],
    function ($, ko, _, eventManager) {

        function DigitalNewsroomFilters(scope, countText, countTextPlural, contentTypeLabel, subjectsLabel, yearLabel, monthLabel, currentMarket, monthList, data) {
            var facetTypes = {
                contentType: "ContentType",
                subjects: "Subjects",
                year: "Year",
                month: "Month"
            };

            //ok
            function init() {
                Object.defineProperty(this, "scope", { enumerable: true, value: scope, writable: !1 });
                Object.defineProperty(this, "$scope", { enumerable: !0, value: $(scope) });
                
                var facetData = getFacetSummary(data, monthList);

                //Create and apply the viewModel
                var stickyNav = $(".sticky-nav.spotlight").get(0);
                var wrapper = $scope.find(".digital-newsroom-filter-wrapper").get(0);

                var viewModel = new FilterViewModel(facetData, data, stickyNav, wrapper);
                
                if (wrapper) {
                    ko.applyBindings(viewModel, wrapper);
                }

                $(".digital-newsroom-filter-button").addClass("prevent-tracking").removeAttr("href");

                $(".digital-newsroom-filter-button").attr("tabindex", "0");
                
                $(".digital-newsroom-filter-button").click(function (e) {
                    viewModel.toggle();
                });

                $(".digital-newsroom-filter-button").on("keypress", function (event) {
                    if (event.keyCode === 13) {
                        $(event.target).click();
                        $(wrapper).find(".digital-newsroom-filter-pane").focus();
                    }
                });
                
                //Close the filter if anything other than the pane or filter button is clicked
                $(document).click(function (e) {
                    if (viewModel.isOpen()) {
                        //If clicked on the filter pane itself, don't close
                        var parents = $(e.target).parents();
                        var filterClicked = parents.hasClass("digital-newsroom-filter-pane") || $(e.target).hasClass("digital-newsroom-filter-pane");

                        if (!filterClicked) {
                            //if a filter button was clicked, ignore the event
                            var buttonClicked = parents.hasClass("digital-newsroom-filter-button") || $(e.target).hasClass("digital-newsroom-filter-button");

                            if (!buttonClicked) {
                                viewModel.hide();
                            }
                        }
                    }
                });
            };

            function getFacetSummary(inputData, monthList) {
                var returnData = {
                    contentTypes: [],
                    subjects: [],
                    years: [],
                    months: []
                };
                
                _.map(monthList,
                    function (month) {
                        returnData.months.push({
                            id: month.Id,
                            name: month.Name,
                            count: 0
                        });
                    });

                //For each facet, if it already exists in the return data, increment the count, otherwise create it
                _.map(inputData,
                    function (data) {

                        var existingContentType = getMatchingFacet(returnData.contentTypes, data[facetTypes.contentType].Id);
                        if (existingContentType) {
                            existingContentType.count++;
                        } else {
                            returnData.contentTypes.push({
                                id: data[facetTypes.contentType].Id,
                                name: data[facetTypes.contentType].Text,
                                count: 1
                            });
                        }

                        _.map(data[facetTypes.subjects],
                            function (subject) {
                                var existing = getMatchingFacet(returnData.subjects, subject.Id);
                                if (existing) {
                                    existing.count++;
                                } else {
                                    returnData.subjects.push({
                                        id: subject.Id,
                                        name: subject.Text,
                                        count: 1
                                    });
                                }
                            });

                        var existingYear = getMatchingFacet(returnData.years, data[facetTypes.year]);
                        if (existingYear) {
                            existingYear.count++;
                        } else {
                            returnData.years.push({
                                id: data[facetTypes.year],
                                name: data[facetTypes.year],
                                count: 1
                            });
                        }
                        
                        var existingMonth = getMatchingFacet(returnData.months, data[facetTypes.month]);
                        existingMonth.count++;
                    });

                return returnData;
            }

            function getMatchingFacet(searchCollection, idToFind) {
                return _.findWhere(searchCollection, { id: idToFind });
            }

            //Given the data collection, return the data that matches the given facet Id
            function filterDataObjectsByFacet(dataCollection, facetType, facetId) {
                if (facetType === facetTypes.contentType) {
                    return _.filter(dataCollection,
                        function (dataObj) {
                            return dataObj[facetTypes.contentType].Id === facetId;
                        });
                } else if (facetType === facetTypes.subjects) {
                    return _.filter(dataCollection,
                        function(dataObj) {
                            return _.some(dataObj[facetType], { Id: facetId });
                        });
                } else {
                    return _.filter(dataCollection,
                        function(dataObj) {
                            return dataObj[facetType] === facetId;
                        });
                }
            }

            //Represents a collection of facets (i.e. content type/industries/products)
            function FacetCollection(name, type, rootViewModel, facetData) {
                var self = this;

                self.name = name;
                self.type = type;
                self.facetLimit = rootViewModel.facetLimit;
                self.rootViewModel = rootViewModel;

                self.facets = ko.observableArray();
                self.isOpen = ko.observable(true);

                self.hasFacets = ko.computed(function () {
                    return self.facets().length > 0;
                });

                //Toggles whether or not all the facets are shown, or only the first 6 (facet limit)
                self.toggle = function () {
                    self.isOpen(!self.isOpen());
                    self.dealWithVisibility();
                };

                //Handles showing/hiding the facets
                self.dealWithVisibility = function () {
                    //If all the facets should be shown, show them
                    if (self.isOpen()) {
                        _.map(self.facets(),
                            function (facet) {
                                facet.isVisible(true);
                            });
                    } else {
                        //Otherwise, only show the first 6 (facet limit)
                        for (var i = 0; i < self.facetCount(); i++) {
                            if (i < self.facetLimit) {
                                self.facets()[i].isVisible(true);
                            } else {
                                self.facets()[i].isVisible(false);
                            }
                        }
                    }

                };

                self.facetCount = ko.computed(function () {
                    return self.facets().length;
                });

                //Should the show more/show less element be displayed?
                self.showExpando = ko.computed(function () {
                    return type !== facetTypes.month && self.facetCount() > self.facetLimit;
                });

                //Add facets to this collection
                self.addFacets = function (collection) {
                    _.map(collection,
                        function (facet) {
                            //If the facet already exists in this collection, increase the count by the number of stories added
                            var existing = getMatchingFacet(self.facets(), facet.name);

                            if (existing != null) {
                                existing.number(existing.number() + facet.count);
                            } else {
                                //Otherwise, create the new facet and add appropriate event subscriptions
                                var facetObj = new FilterFacet(facet.id, facet.name, self.name);
                                facetObj.number(facet.count);

                                facetObj.addSelectedSubscription(self.rootViewModel);

                                self.facets.push(facetObj);
                            }
                        });
                    
                    if (type === facetTypes.month) {
                        self.facets(_.sortBy(self.facets(), "id"));
                        self.isOpen(true);
                    }
                    else {
                    //Sort the facets into alphabetical order
                        self.facets(_.sortBy(self.facets(), "name"));
                    }
                    self.dealWithVisibility();
                }

                //Subtract the stories that are no longer relevant (i.e. a market was deselected)
                self.subtractFacets = function (toSubtract, toKeep) {
                    //Remove facets that are not included in the toKeep collection 
                    var filtered = _.filter(self.facets(),
                        function (facet) {
                            var existing = filterDataObjectsByFacet(toKeep, self.type, facet.id);
                            return existing !== null && existing !== undefined && existing.length > 0;
                        });

                    //For facets that are about to be removed, unsubscribe from the selected event 
                    _.map(self.facets(),
                        function (facet) {
                            if (!_.contains(filtered, facet)) {
                                facet.removeSelectedSubscription();
                            }
                        });

                    self.facets(filtered);

                    //For each facet in this FacetCollection, subtract the count of the removed facet from the existing one
                    _.map(toSubtract,
                        function (facet) {
                            var existing = getMatchingFacet(self.facets(), facet.name);
                            if (existing != null) {
                                existing.number(existing.number() - facet.count);
                            }
                        });

                    self.dealWithVisibility();
                }

                //Programmatically select the specified facets
                self.selectFacets = function (toSelect, deselectOthers) {
                    _.map(self.facets(),
                        function (facet) {
                            if (_.contains(toSelect, facet.name)) {
                                facet.selected(true);
                            } else {
                                if (deselectOthers) {
                                    facet.selected(false);
                                }
                            }
                        });
                }

                //Reset the collection to default (i.e. nothing selected)
                self.reset = function () {
                    _.map(self.facets(),
                        function (facet) {
                            facet.enable();
                            facet.selected(false);
                        });

                    self.dealWithVisibility();
                }

                //Return the facets that are currently selected
                self.getSelectedFacets = function () {
                    var selected = [];
                    _.map(self.facets(),
                        function (facet) {
                            if (facet.selected()) {
                                selected.push(facet);
                            }
                        });

                    return selected;
                }

                self.recalculateCounts = function (dataCollection, selectedDict) {
                    var filterToApply = {};
                    filterToApply[facetTypes.contentType] = selectedDict[facetTypes.contentType];
                    filterToApply[facetTypes.subjects] = selectedDict[facetTypes.subjects];
                    filterToApply[facetTypes.year] = selectedDict[facetTypes.year];
                    filterToApply[facetTypes.month] = selectedDict[facetTypes.month];

                    //Remove own type from the considerations
                    filterToApply[self.type] = [];

                    recalculateCountsUsingFilter(dataCollection, filterToApply);
                }

                //it enables and disables the filters based on selected options
                function recalculateCountsUsingFilter(dataCollection, filterData) {
                    _.map(self.facets(),
                        function (facet) {
                            //first of all, get the data that is relevant to this particular facet
                            var relevantData = filterDataObjectsByFacet(dataCollection, self.type, facet.id);

                            //next, need to further filter the data to make sure it adheres to the other aspects of the filter
                            if (filterData[facetTypes.contentType].length > 0) {
                                relevantData = _.filter(relevantData,
                                    function (dataObj) {
                                        //if the data adheres to any of the content types, then it is valid
                                        return _.some(filterData[facetTypes.contentType],
                                            { id: dataObj[facetTypes.contentType].Id });
                                    });
                            }
                            
                            if (filterData[facetTypes.subjects].length > 0) {
                                relevantData = _.filter(relevantData,
                                    function (dataObj) {
                                        //if the data adheres to any of the subjects, it is valid
                                        var matchingSubjects = _.filter(dataObj[facetTypes.subjects],
                                            function (dataObjSubject) {
                                                return _.some(filterData[facetTypes.subjects],
                                                    { id: dataObjSubject.Id });
                                            });

                                        return matchingSubjects.length > 0;
                                    });
                            }

                            if (filterData[facetTypes.year].length > 0) {
                                relevantData = _.filter(relevantData,
                                    function (dataObj) {
                                        return _.some(filterData[facetTypes.year],
                                            { id: dataObj[facetTypes.year] });
                                    });
                            }

                            if (filterData[facetTypes.month].length > 0) {
                                relevantData = _.filter(relevantData,
                                    function (dataObj) {
                                        return _.some(filterData[facetTypes.month],
                                            { id: dataObj[facetTypes.month] });
                                    });
                            }

                            facet.updateCount(relevantData.length);
                        });
                }

                //Function to get the data that matches any of the facets that are selected in this collection
                //If no facets are selected, will return the unmodified collection
                self.filterDataUsingSelectedFacets = function (dataCollection) {
                    var selectedFacets = self.getSelectedFacets();
                    if (selectedFacets.length > 0) {
                        var selectedFacetIds = _.pluck(selectedFacets, "id");

                        if (self.type === facetTypes.contentType) {
                            dataCollection = _.filter(dataCollection,
                                function (dataObj) {
                                    return _.contains(selectedFacetIds, dataObj[facetTypes.contentType].Id);
                                });
                        } else if (self.type === facetTypes.subjects) {
                            dataCollection = _.filter(dataCollection,
                                function (dataObj) {
                                    //Need to check each of the facet entries on the data itself
                                    return _.some(dataObj[self.type],
                                        function (dataObjFacet) {
                                            return _.contains(selectedFacetIds, dataObjFacet.Id);
                                        });
                                });
                        }
                        else {
                            dataCollection = _.filter(dataCollection,
                                function (dataObj) {
                                    return _.contains(selectedFacetIds, dataObj[self.type]);
                                });
                        }
                    }
                    return dataCollection;
                }
                
                self.addFacets(facetData);
            }

            //Represents an individual facet
            function FilterFacet(id, name, collectionName) {
                var self = this;
                self.id = id;
                self.name = name;
                self.collectionName = collectionName;

                self.selectedSubscription = null;

                self.selected = ko.observable(false);
                self.isDisabled = ko.observable(false);
                self.isVisible = ko.observable(false);
                self.number = ko.observable(0);

                //Update the count of stories connected to this facet
                self.updateCount = function (number) {
                    self.number(number);
                    //If there are no stories, disable this facet
                    if (number === 0) {
                        self.disable();
                    } else {
                        self.enable();
                    }
                };

                //Display text for the number of stories connected to this facet
                self.countText = ko.computed(function () {
                    if (self.number() > 0) {
                        return "(" + self.number() + ")";
                    } else {
                        return null;
                    }
                });

                self.enable = function () {
                    self.isDisabled(false);
                };

                self.disable = function () {
                    self.isDisabled(true);
                    self.selected(false);
                };

                self.toggle = function () {
                    if (!self.isDisabled()) {
                        var newVal = !self.selected();
                        self.selected(newVal);
                    }
                };

                self.keyPress = function (data, event) {
                    $(event.target).click();
                }

                //Add a subscription to update the filter when this facet is selected
                self.addSelectedSubscription = function (rootViewModel) {
                    self.selectedSubscription = self.selected.subscribe(function () {
                        rootViewModel.updatefilter();
                    });
                }

                //Remove the subscription from memory
                self.removeSelectedSubscription = function () {
                    if (self.selectedSubscription != null) {
                        self.selectedSubscription.dispose();
                    }
                }
            }

            function FilterViewModel(facetData, data, stickyNav, wrapper) {
                var self = this;
                self.countTextSelector = ".digital-newsroom-listings .resources-count";

                self.isOpen = ko.observable(false);
                self.paneIsOpen = ko.observable(false);
                self.isResetting = false;
                self.isInitialising = false;

                self.debounceQuerystringUpdate = _.debounce(function (queryStringDict) {
                    var queryString = "?";
                    _.map(queryStringDict,
                        function (entry, key) {
                            if (entry.length > 0 && key.length > 0) {
                                if (queryString !== "?") {
                                    queryString += "&";
                                }
                                queryString += key + "=" + entry;
                            }
                        });

                    history.pushState("", "", queryString);
                }, 500);

                //The maximum number of facets that should be shown without "expanding" the collection
                //months is the exception here
                self.facetLimit = 6;
                
                self.isFiltered = ko.observable(false);
                self.totalCount = ko.observable(data.length);
                self.filteredDataCount = ko.observable(data.length);
                self.facetCollections = ko.observableArray();

                function initViewModel() {
                    self.isInitialising = true;
                    self.isResetting = true;

                    self.facetCollections().push(new FacetCollection(contentTypeLabel, facetTypes.contentType, self, facetData.contentTypes));
                    self.facetCollections().push(new FacetCollection(subjectsLabel, facetTypes.subjects, self, facetData.subjects));
                    self.facetCollections().push(new FacetCollection(yearLabel, facetTypes.year, self, facetData.years));
                    self.facetCollections().push(new FacetCollection(monthLabel, facetTypes.month, self, facetData.months));

                    var shouldOpen = $.Querystring("openFilter") || "";
                    
                    //For each facet type
                    _.map(self.facetCollections(),
                        function (facetCollection) {
                            //If the facet is selected in the querystring, select it in the model
                            var queryString = $.Querystring(facetCollection.type) || "";
                            if (queryString.length > 0) {
                                var toSelect = [];
                                var selectedFacets = queryString.split(",");
                                _.map(selectedFacets,
                                    function (facet) {
                                        toSelect.push(facet);
                                    });

                                facetCollection.selectFacets(toSelect, false);
                            }

                            facetCollection.dealWithVisibility();
                        });

                    self.isResetting = false;
                    self.updatefilter();
                    self.isInitialising = false;

                    $(self.countTextSelector).show();
                    if (shouldOpen) {
                        self.show();
                    } else {
                        self.pinWrapperBelowStickyNav();
                    }
                }
                
                self.pinWrapperBelowStickyNav = function () {
                    if (stickyNav) {
                        var newTop = stickyNav.getBoundingClientRect().bottom;
                        $(wrapper).css("top", newTop + "px");
                    }
                };

                //Toggle the filter pane
                self.toggle = function () {
                    var opening = false;
                    if (self.isOpen()) {
                        self.hide();
                    } else {
                        opening = true;
                        self.show();
                    }

                    return opening;
                };

                self.hide = function () {
                    if (self.paneIsOpen()) {
                        self.paneIsOpen(false);
                        window.setTimeout(function() {
                                self.isOpen(false);
                                $("body").removeClass("digital-newsroom-no-scroll");
                            },
                            500);
                    }
                };

                self.show = function () {
                    if (!self.isOpen()) {
                        self.isOpen(true);
                        $("body").addClass("digital-newsroom-no-scroll");
                        window.setTimeout(function() {
                                self.paneIsOpen(true);
                                window.setTimeout(function() {
                                        self.pinWrapperBelowStickyNav();
                                    },
                                    200);
                            },
                            200);
                    }
                };
                
                //The text for displaying the count (e.g. X of Y stories)
                self.countText = ko.computed(function () {
                    if (self.filteredDataCount() === 1) {
                        return countText.replace("##", self.totalCount()).replace("#", self.filteredDataCount());
                    }
                    return countTextPlural.replace("##", self.totalCount()).replace("#", self.filteredDataCount());
                });

                self.keyPress = function (data, event) {
                    $(event.target).click();
                }

                self.resetClick = function () {
                    self.reset();
                }

                //Reset the filter
                self.reset = function () {
                    self.isResetting = true;

                    //Reset the collections
                    _.map(self.facetCollections(),
                        function (facetCollection) {
                            facetCollection.reset();
                        });

                    eventManager.trigger("digital-newsroom-filter-reset-clicked");

                    self.isResetting = false;
                    self.updatefilter();
                }

                eventManager.subscribe("digital-newsroom-filter-reset", function () {
                    self.reset();
                });

                eventManager.subscribe("digital-newsroom-filter-result-page-change", function (filterDict) {
                    self.isResetting = true;
                    _.map(self.facetCollections(),
                        function (facetCollection) {
                            var selectedFacetNames = _.pluck(filterDict[facetCollection.type], "name");
                            facetCollection.selectFacets(selectedFacetNames, true);
                        });

                    self.isResetting = false;
                    self.updatefilter();
                });
                
                //When filter is applied
                //Determine the count for each facet - filter the data by ones that the filter applies to, and the facet in question
                self.updatefilter = function () {
                    if (!self.isResetting) {
                        var isBeingFiltered = false;
                        var selectedDict = {};
                        var queryString = window.location.search.split("&");

                        var queryStringDict = {};
                        _.map(queryString,
                            function (entry) {
                                var splitQuery = entry.split("=");
                                var queryValue = splitQuery[1] || "";
                                var keyName = splitQuery[0];
                                if (keyName.charAt(0) === "?") {
                                    keyName = keyName.slice(1);
                                }
                                queryStringDict[keyName] = queryValue.split(",");
                            });

                        //For each facet collection
                        _.map(self.facetCollections(),
                            function (facetCollection) {
                                selectedDict[facetCollection.type] = facetCollection.getSelectedFacets();
                                //If any facets are selected, add the category to the querystring
                                if (selectedDict[facetCollection.type].length > 0) {
                                    //Add the selected facets to the querystring
                                    var names = _.pluck(selectedDict[facetCollection.type], "name");
                                    queryStringDict[facetCollection.type] = names;
                                } else {
                                    queryStringDict[facetCollection.type] = "";
                                }
                            });


                        //Have a list of the facets that have been selected
                        //Need to have the counts adjust - only considering all the *other* facets
                        //Update the counts for every facet in every collection
                        _.map(self.facetCollections(),
                            function (facetCollection) {
                                facetCollection.recalculateCounts(data, selectedDict);
                            });

                        //Next, filter the data to know how many are selected - this must be done second
                        var filteredData = data;
                        _.map(self.facetCollections(),
                            function (facetCollection) {
                                filteredData = facetCollection.filterDataUsingSelectedFacets(filteredData);
                            });

                        if (selectedDict[facetTypes.contentType].length > 0 ||
                            selectedDict[facetTypes.subjects].length > 0 ||
                            selectedDict[facetTypes.year].length > 0 ||
                            selectedDict[facetTypes.month].length > 0) {
                            isBeingFiltered = true;
                        }

                        self.isFiltered(isBeingFiltered);
                        self.filteredDataCount(filteredData.length);

                        selectedDict["digitalNewsroomResultsData"] = filteredData;
                        selectedDict["unfilteredCount"] = data.length;

                        eventManager.trigger("digital-newsroom-filter-changed", selectedDict);
                        
                        if (!self.isInitialising) {
                            self.debounceQuerystringUpdate(queryStringDict);
                        }
                    }
                };

                initViewModel();
            };

            init();
        };

        return function DigitalNewsroomFilter(args) {
            return args.IsExperienceEditorEditing === false ?
                new DigitalNewsroomFilters(args.scope,
                    args.countText,
                    args.countTextPlural,
                    args.contentTypeLabel,
                    args.subjectsLabel,
                    args.yearLabel,
                    args.monthLabel,
                    args.currentMarket,
                    args.monthList,
                    args.data) : null;
        };
    });
